import React, { useRef } from "react";

export default function ThreeThumbSlider({
  value = [0, 50, 100],
  min = 0,
  max = 100,
  step = 1,
  onChange,
  className = "",
}) {
  const trackRef = useRef(null);
  const clamp = (x) =>
    Math.min(max, Math.max(min, Math.round(x / step) * step));
  const pct = (v) => ((v - min) * 100) / (max - min);

  const posToVal = (clientX) => {
    const rect = trackRef.current.getBoundingClientRect();
    const p = (clientX - rect.left) / rect.width;
    return clamp(min + p * (max - min));
  };

  const startDrag = (index, e) => {
    e.preventDefault();
    const move = (ev) => {
      const clientX = ev.clientX || (ev.touches && ev.touches[0].clientX);
      const v = posToVal(clientX);
      const next = [...value];
      if (index === 0) next[0] = Math.min(v, next[1] - 1);
      if (index === 1)
        next[1] = Math.max(next[0] + 1, Math.min(v, next[2] - 1));
      if (index === 2) next[2] = Math.max(v, next[1] + 1);
      onChange?.(next);
    };
    const up = () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseup", up);
      window.removeEventListener("touchmove", move);
      window.removeEventListener("touchend", up);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseup", up);
    window.addEventListener("touchmove", move);
    window.addEventListener("touchend", up);
  };

  return (
    <div className={className}>
      <div
        ref={trackRef}
        className="relative h-1.5 bg-white border border-[#EFEFEF] rounded"
      >
        <div
          className="absolute top-0 h-1.5  rounded mx-1"
          style={{
            left: `${pct(value[0])}%`,
            width: `${pct(value[2]) - pct(value[0])}%`,
          }}
        />
        {[0, 1, 2].map((i) => (
          <button
            key={i}
            onMouseDown={(e) => startDrag(i, e)}
            onTouchStart={(e) => startDrag(i, e)}
            className="absolute -mt-1 w-0 h-0"
            style={{
              left: `calc(${pct(value[i])}% - 9px)`,
              top: "0px",
            }}
            aria-label={i === 0 ? "black" : i === 1 ? "mid" : "white"}
          >
            <svg width="18" height="15" viewBox="0 0 18 15" fill="none">
              <path
                d="M7.26795 1C8.03775 -0.333332 9.96225 -0.333333 10.7321 1L16.7942 11.5C17.564 12.8333 16.6018 14.5 15.0622 14.5H2.93782C1.39822 14.5 0.435971 12.8333 1.20577 11.5L7.26795 1Z"
                fill="#20C3FF"
              />
            </svg>
          </button>
        ))}
      </div>
    </div>
  );
}
